var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarkKalkLoesend = function SvgStarkKalkLoesend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Stark_Kalk_loesend_svg__Ebene_2",
    viewBox: "0 0 98.51 84.34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Stark_Kalk_loesend_svg__cls-1,.Stark_Kalk_loesend_svg__cls-3{stroke:currentColor;stroke-miterlimit:10}.Stark_Kalk_loesend_svg__cls-1{stroke-width:2.4px;fill:none}.Stark_Kalk_loesend_svg__cls-3{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Stark_Kalk_loesend_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.83 50.81 13.66 17.58c3.92 6.45-.73 14.71-8.28 14.71H25.79c-7.55 0-12.2-8.26-8.28-14.71l26.26-33.73c1.93-3.18 6.54-3.18 8.47 0L64.83 50.8Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.48px"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.68,
    cy: 46.14,
    r: 1.74,
    className: "Stark_Kalk_loesend_svg__cls-3",
    transform: "rotate(-1.59 49.816 46.101)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.33,
    cy: 52.22,
    r: 1.74,
    className: "Stark_Kalk_loesend_svg__cls-3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.94,
    cy: 53.96,
    r: 1.74,
    className: "Stark_Kalk_loesend_svg__cls-3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.59,
    cy: 61.14,
    r: 1.74,
    className: "Stark_Kalk_loesend_svg__cls-3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3,
    cy: 11.99,
    r: 8.15,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6,
    cy: 25.84,
    r: 5.94,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.74,
    cy: 8.25,
    r: 7.05,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.71,
    cy: 25.64,
    r: 4.62,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.16,
    cy: 31.41,
    r: 8.15,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 31.86,
    r: 7.05,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6,
    cy: 10.26,
    r: 4.62,
    className: "Stark_Kalk_loesend_svg__cls-1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.32,
    cy: 9.5,
    r: 7.05,
    className: "Stark_Kalk_loesend_svg__cls-1"
  }))));
};
export default SvgStarkKalkLoesend;